export enum C2cOnChangeTypeAction {
	Longs,
	Width,
	Height,
}
